import { render } from "./LoginComponent.vue?vue&type=template&id=2dd1bc04&ts=true"
import script from "./LoginComponent.vue?vue&type=script&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&lang=ts"

import "./LoginComponent.vue?vue&type=style&index=0&id=2dd1bc04&lang=css"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__